import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  z-index: 1;

  ${({ theme }) => `
    padding:
      ${theme.space.desktop.small}
      ${theme.space.desktop.small}
      ${theme.space.desktop.large};
  `}
`

export const VersionWrapper = styled.div`
  text-align: center;
  opacity: 0.7;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.tiny};
  `}
`
